/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react/no-array-index-key */
import PAImage from "component/design-system/images/PAImage";
import Link from "next/link";
import HideIf from "util/HideIf";

interface Props {
    useVizSensor : any,
    title: any,
    imagesUrlV2 : any,
    imgSrc: any,
    imagesUrl: any,
}

// http://localhost:3000/how-to-fix-car-tail-lights
function TopBottomItems(props: Props) {
  const {
    useVizSensor,
    title,
    imagesUrlV2,
    imgSrc,
    imagesUrl,
  } = props;
  const mobileImage = imagesUrlV2 && imagesUrlV2.find((image: any) => image.screen === "MOBILE" && image.imagesUrl);
  const desktopImages = imagesUrlV2 && imagesUrlV2.find((image: any) => image.screen === "DESKTOP" && image.imagesUrl);

  // / http://localhost:3000/how-to-fix-car-tail-lights
  if (imagesUrlV2 && (mobileImage || desktopImages)) {
    return <>

      <div className="hidden-sm hidden-md hidden-lg">

        <HideIf show={mobileImage?.url}>

          <Link href={mobileImage?.url}>

            <PAImage
              src={`${imgSrc}${mobileImage?.imagesUrl}`}
              height={mobileImage?.height}
            />

          </Link>
        </HideIf>

        <HideIf show={!mobileImage?.url}>

          <PAImage
            src={`${imgSrc}${mobileImage?.imagesUrl}`}
            height={mobileImage?.height}
          />
        </HideIf>

      </div>

      <div className="hidden-xs">

        <HideIf show={desktopImages?.url}>

          <Link href={desktopImages?.url}>

            <PAImage
              src={`${imgSrc}${desktopImages?.imagesUrl}`}
              height={desktopImages?.height}
            />

          </Link>
        </HideIf>

        <HideIf show={!desktopImages?.url}>

          <PAImage
            src={`${imgSrc}${desktopImages?.imagesUrl}`}
            height={desktopImages?.height}
          />
        </HideIf>
      </div>
    </>;
  }

  //  http://localhost:3000/how-to-fix-car-tail-lights
  if (imagesUrl && imagesUrl?.length > 0) {
    return imagesUrl.map((url: any, index3: any) => (
      <div key={index3}>

        {/* http://localhost:3000/headlights-buying-guide#kelvin_rating */}
        <PAImage
          lazyLoad={useVizSensor}
          className="img-responsive"
          src={`${imgSrc}${url}`}
          alt={title}
        />
      </div>
    ));
  }

  return <></>;
}

export default TopBottomItems;
